import { useRef, useState } from 'react'

import ControlsBar, { ControlsBarSpace } from 'app/common/ui-next/controls-bar'
import PlainButton from 'app/common/ui-next/plain-button'
import DishesData from 'app/dataProviders/dishes/DishesData'
import SaleTypesData from 'app/dataProviders/SaleTypesData'
import PlainInputSearch from 'app/common/ui-next/plain-input-search'
import useDebouncedSearch from 'app/common/hooks/useDebouncedSearch'
import { useCheckedCount } from 'app/common/templates-next/table-template'
import getNumEnding from 'app/common/lib/getNumEnding'
import { Dish } from 'app/dataTypes/dishes/dish'

import PlainModal, {
  PlainModalContent,
  PlainModalFooter,
  PlainModalHeader,
} from 'app/common/ui-next/plain-modal'

import { DishesTable } from '../DishesTableV2'
import { AddRawItemsPager } from './AddRawItemsPager'
import { PinnedDishesState } from './PinnedDishesState'
import { useRawItemsSettings } from '../../SettingsGear/useRawItemsSettings'
import RawItemsGear from '../../SettingsGear/RawItemsGear'

import styles from './AddRawItemsModal.modules.scss'

export const AddRawItemsModal = ({
  onClose,
  onAddRawItems,
}: {
  onClose: () => void
  onAddRawItems?: (dishes: Array<Dish>) => void
}) => {
  const pinnedDishes = useRef<Array<Dish>>([])
  const [enableSubmit, setEnableSubmit] = useState(false)

  const [search, setSearch] = useState('')
  const [searchString, handleSearch, handleClearSearch] = useDebouncedSearch(setSearch, () =>
    setSearch(''),
  )

  const checkedCount = useCheckedCount()

  const { rows, ...settings } = useRawItemsSettings()

  const handlePinnedDishes = (dishes: Array<Dish>) => {
    pinnedDishes.current = dishes
    setEnableSubmit(!!dishes.length)
  }

  const handleSubmit = () => {
    if (onAddRawItems) {
      onAddRawItems(pinnedDishes.current)
    }
    onClose()
  }

  return (
    <DishesData limit={rows} search={search}>
      <SaleTypesData>
        <PlainModal className={styles.root} show formId="addRawItems" onSubmit={handleSubmit}>
          <PlainModalHeader onCrossClick={onClose}>
            {'Добавить сырье'}
            {checkedCount > 0 && (
              <span
                className={styles.selectedCountText}
              >{`\u00A0— ${getNumEnding(checkedCount, ['выбрана', 'выбраны', 'выбрано'])} ${checkedCount} ${getNumEnding(checkedCount, ['позиция', 'позиции', 'позиций'])}`}</span>
            )}
          </PlainModalHeader>

          <PlainModalContent unscrollable borderBottom>
            <ControlsBar>
              <PlainInputSearch
                placeholder="Поиск"
                className={styles.search}
                value={searchString}
                onChange={handleSearch}
                clearSearch={handleClearSearch}
                autoFocus
              />
              <ControlsBarSpace />
              <RawItemsGear disabledSetup />
            </ControlsBar>
          </PlainModalContent>
          <PlainModalContent
            paddingFree
            containerClassName={styles.scrolls}
            minHeight="65vh"
            maxHeight="65vh"
          >
            <PinnedDishesState>
              {({ pinnedDishesIds }) => (
                <DishesTable
                  resetStickyShift
                  skeletonRows={20}
                  pinnedDishesIds={pinnedDishesIds}
                  onPinnedDishes={handlePinnedDishes}
                  settings={{ ...settings, options: false }}
                  keepCheckboxesRegisteredOnDispose
                  hideSelectAll
                />
              )}
            </PinnedDishesState>
          </PlainModalContent>

          <PlainModalFooter>
            <ControlsBar right>
              <AddRawItemsPager />
              <ControlsBarSpace />
              <PlainButton onClick={onClose} outline>
                {'Отмена'}
              </PlainButton>
              <PlainButton type="submit" disabled={!enableSubmit}>
                {'Подтвердить'}
              </PlainButton>
            </ControlsBar>
          </PlainModalFooter>
        </PlainModal>
      </SaleTypesData>
    </DishesData>
  )
}
